/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_LockInputs */



/**
* | output |
* | --- |
* | "Lock" |
*
* @param {Event_Group_Options_LockInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_lock = /** @type {((inputs?: Event_Group_Options_LockInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_LockInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lock")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lock")
	if (locale === "it") return /** @type {LocalizedString} */ ("Lock")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Lock")
	if (locale === "es") return /** @type {LocalizedString} */ ("Lock")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Lock")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Lock")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Lock")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Lock")
	return /** @type {LocalizedString} */ ("Lock")
});